module.exports = __webpack_public_path__ + "static/media/girl (2).84ca8032.png";